(function () {
  var SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var cssLoaded = false;
  var jsPromise = null;

  function loadCss() {
    if (cssLoaded) return;
    cssLoaded = true;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = SWIPER_CSS;
    document.head.appendChild(link);
  }

  function loadJs() {
    if (jsPromise) return jsPromise;
    jsPromise = new Promise(function (resolve, reject) {
      if (window.Swiper) return resolve(window.Swiper);
      var s = document.createElement('script');
      s.src = SWIPER_JS;
      s.async = true;
      s.onload = function () { resolve(window.Swiper); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return jsPromise;
  }

  function addCartHandler(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wh2-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      btn.disabled = true;
      var original = btn.textContent;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) { return r.json().then(function (j) { throw j; }); }
          return r.json();
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.publish && FoxTheme.pubsub.PUB_SUB_EVENTS) {
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'wh2-product-card' });
          }
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1600);
        })
        .catch(function (err) {
          console.error('add to cart failed', err);
          btn.textContent = (err && err.description) ? 'Sold out' : 'Try again';
          setTimeout(function () {
            btn.textContent = original;
            btn.disabled = false;
          }, 1600);
        });
    });
  }

  function initCarousel(root) {
    if (!root || root.dataset.wh2ProductsInit === '1') return;
    root.dataset.wh2ProductsInit = '1';

    addCartHandler(root);

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.disconnect();

        loadCss();
        loadJs().then(function (Swiper) {
          var container = root.querySelector('.swiper');
          if (!container) return;
          new Swiper(container, {
            slidesPerView: 1.15,
            spaceBetween: 14,
            breakpoints: {
              640: { slidesPerView: 2.2, spaceBetween: 18 },
              900: { slidesPerView: 3.2, spaceBetween: 20 },
              1200: { slidesPerView: 4, spaceBetween: 24 }
            },
            navigation: {
              nextEl: root.querySelector('[data-wh2-next]'),
              prevEl: root.querySelector('[data-wh2-prev]')
            },
            keyboard: { enabled: true }
          });
        });
      });
    }, { rootMargin: '200px 0px' });

    observer.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-wh2-products]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
